import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';

import { environment } from './src/environments/environment';

// todo: replace with opt chaining
const level =
  environment &&
  environment.logging &&
  environment.logging.level &&
  NgxLoggerLevel[environment.logging.level]
    ? NgxLoggerLevel[environment.logging.level]
    : 'INFO';

const disableConsoleLogging =
  environment && environment.logging && environment.logging.disableConsoleLogging;

@NgModule({
  imports: [
    CommonModule,
    LoggerModule.forRoot({
      level,
      disableConsoleLogging,
      timestampFormat: 'h:mm:ss.SSS',
    }),
  ],
  exports: [LoggerModule],
})
export class VmeLoggerModule {}
